import { useContext } from 'react';
import { ClientDataContext } from './ClientDataContext';

export const useClientData = () => {
    return useContext(ClientDataContext);
};
